module.exports = __webpack_public_path__ + "static/img/pic4.d919cef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case4/pic4.jpg
// module id = wrKM
// module chunks = 1